import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eCauHinhXeBusActionTypeIds, ICauHinhXeBusActionTypes } from "../../action-types/bus/ICauHinhXeBusActionTypes";
import { ICauHinhXeBusPageStateModel } from "../../page-state-model/bus/ICauHinhXeBusPageState";

const initialState: ICauHinhXeBusPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	dm_cauhinhxebus_items: [],
	dm_cauhinhxebus_editing: undefined,
	dm_cauhinhxebus_selected_ids: [],
	is_show_delete_confirm: false,
	is_show_detail_modal: false
}
export const cauHinhXeBusReducer = (state: ICauHinhXeBusPageStateModel = initialState, action: ICauHinhXeBusActionTypes): ICauHinhXeBusPageStateModel => {
	switch (action.type) {
		case eCauHinhXeBusActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eCauHinhXeBusActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				dm_cauhinhxebus_items: action.payload
			}
		case eCauHinhXeBusActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				dm_cauhinhxebus_items: []
			}
		case eCauHinhXeBusActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				dm_cauhinhxebus_editing: action.payload
			}
		case eCauHinhXeBusActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				dm_cauhinhxebus_editing: undefined
			}
		case eCauHinhXeBusActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				dm_cauhinhxebus_selected_ids: action.payload
			}
		case eCauHinhXeBusActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eCauHinhXeBusActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eCauHinhXeBusActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eCauHinhXeBusActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false
			}
		case eCauHinhXeBusActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eCauHinhXeBusActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eCauHinhXeBusActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				dm_cauhinhxebus_editing: undefined
			}
		case eCauHinhXeBusActionTypeIds.SAVE_ERR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
